export default "__VITE_ASSET__FGcCurJC__"